import { broadbandSubmitApi } from '@/api/broadband'
let initState = {
  goodsObj: {},
  shopObj: {},
  cityObj: {},
  formObj: {},
  goodsInfo: {},
  numbers: {},
  pageInit: true,
  cellPhoneOperator: '',
  pageCache: {
    //     省市县 cityObj: {},
    cityName: '', //所在地区
    storeList: [], // 门店列表
    storeSearchText: '',
    storeName: '', //门店名字
    postAddr: '', // 搜索
    goodsList: [], // 商品列表
  },
  businessType: 1,
  cachedViews: [],
  uniqueID: '',
  payPrice: '',
  deliveryMethod: '',
  specsId: '',
  specsText: '',
}

let cloneDeep = (data) => {
  //copy一份数据
  return JSON.parse(JSON.stringify(data))
}
const state = cloneDeep(initState)
const mutations = {
  SET_SPECSTEXT: (state, specsText) => {
    state.specsText = specsText
  },

  SET_PAYPRICE: (state, payPrice) => {
    state.payPrice = payPrice
  },
  SET_SPECSID: (state, specsId) => {
    state.specsId = specsId
  },
  SET_DELIVERYMETHOD: (state, deliveryMethod) => {
    state.deliveryMethod = deliveryMethod
  },

  SET_CACHEDVIEWS: (state, cachedViews) => {
    state.cachedViews = cachedViews
  },
  SET_BUSINESSTYPE: (state, businessType) => {
    state.businessType = businessType
  },
  SET_UNIQUEID: (state, uniqueID) => {
    state.uniqueID = uniqueID
  },
  SET_PAGECACHE: (state, pageCache) => {
    state.pageCache = pageCache
  },
  SET_CELLPHONEOPERATOR: (state, cellPhoneOperator) => {
    state.cellPhoneOperator = cellPhoneOperator
  },
  SET_NUMBERS: (state, numbers) => {
    state.numbers = numbers
  },
  SET_GOODSOBJ: (state, goodsObj) => {
    state.goodsObj = goodsObj
  },
  SET_GOODSINFO: (state, goodsInfo) => {
    state.goodsInfo = goodsInfo
  },
  SET_SHOPOBJ: (state, shopObj) => {
    state.shopObj = shopObj
  },
  SET_CITY: (state, cityObj) => {
    state.cityObj = cityObj
  },
  SET_FORM: (state, formObj) => {
    state.formObj = formObj
  },

  SET_CITYNAME: (state, cityName) => {
    state.cityName = cityName
  },
  INIT_STATE: (state) => {
    Object.assign(state, initState)
  },
  SET_FORM_POSTADDR: (state, data) => {
    state.formObj.postAddr = data
  },
  SET_PAGEINIT: (state) => {
    state.pageInit = false
  },
}
const actions = {
  setGoodsObj({ commit }, data) {
    commit(`SET_GOODSOBJ`, data)
  },
  setGoodsInfo({ commit }, data) {
    commit(`SET_GOODSINFO`, data)
  },
  setShopObj({ commit }, data) {
    commit(`SET_SHOPOBJ`, data)
  },
  setCity({ commit }, data) {
    commit(`SET_CITY`, data)
  },
  setForm({ commit }, data) {
    commit(`SET_FORM`, data)
  },
  setFormPostAddr({ commit }, data) {
    commit(`SET_FORM_POSTADDR`, data)
  },
  setNumbers({ commit }, data) {
    commit(`SET_NUMBERS`, data)
  },
  async onsubmit({
    state: {
      cityObj,
      formObj,
      numbers,
      cellPhoneOperator,
      goodsObj: { offerType, picture, pictureUrl, weight, name, title, longTitle, contractPeriod, brandRate },
      shopObj: { yytCode: hallCode, yytName: hallName, provCode: provinceCode, provName: provinceName, latnName: cityName, latnCode: cityCode, areaName: districtName, areaCode: districtCode },
      goodsInfo: { id, code, state, skuExpandOao, type, type2, detailList ,version},
      payPrice,
      deliveryMethod,
      businessType,
      uniqueID,
    },
    rootGetters,
  }) {
    const params = {
      channel: rootGetters.channel, //必填	string	渠道号
      cardType: rootGetters.cardTypes[0].card_type, // 必填	String	卡类型，宽带产品订购
      //cardType: `500kd`,
      mediaLink: window.location.href, //必填	string	下单媒体完整链接
      ...cityObj,
      ...formObj,
      deliveryMethod: businessType == 1 ? 1 : deliveryMethod,
      numbers,
      cellPhoneOperator,
      serialNumber: '', // 非必填	string	宽带订购选号必须填，长度不超过15个字符
      provinceCode, // 必填	string	省代码，厅店信息查询接口返回
      provinceName, // 必填	string	省份名称，厅店信息查询接口返回
      cityCode, // 必填	string	地市代码，厅店信息查询接口返回
      cityName, // 必填	string	地市名称，厅店信息查询接口返回
      districtCode, // 必填	string	区县代码，厅店信息查询接口返回
      districtName, // 必填	string	区县名称，厅店信息查询接口返回
      //   offerType: offerType || "",
      skuInfo: {
        id, //	必填	string	skuId
        version, //	必填	string	sku数据版本
        code, //	-	必填	string	sku编码
        state, //	-	必填	string	sku状态
        name, //	-	必填	string	sku名称
        title, //	-	必填	string	短标题
        longTitle, //	-	必填	string	长标题
        picture, //-	必填	string	主图
        pictureUrl, //	-	必填	string	主图URL
        terminalPrice: skuExpandOao.terminalPrice, //	-	必填	string	价格
        weight, //	-	必填	string	权重
        contractPeriod, //	-	必填	string	合约期
        brandRate, //	-	必填	string	带宽
        goodsId: businessType == 2 ? uniqueID : getArrayIds(detailList),
        //  goodsId:getArrayIds(detailList),
        type2,
        type,
      },
      hallInfo: {
        provinceCode, //	必填	string	省代码（厅店信息查询接口返回）
        provinceName, //	必填	string	省份名称（厅店信息查询接口返回）
        cityCode, //	必填	string	地市代码（厅店信息查询接口返回）
        cityName, //	必填	string	地市名称（厅店信息查询接口返回）
        districtCode, //必填	string	区县代码（厅店信息查询接口返回）
        districtName, //	必填	string	区县名称（厅店信息查询接口返回）
        hallCode, //营业厅编码（厅店信息查询接口返回）
        hallName, //营业厅名称（厅店信息查询接口返回）
      },
      payInfo: {
        payPrice: businessType == 1 ? skuExpandOao.terminalPrice : payPrice, // 支付金额（sku明细接口返回）
        payMethod: skuExpandOao.payMethod, // 支付方式（sku明细接口返回）
      },
      isSelectNum: skuExpandOao.isSelectNum,
      fuCardNum: skuExpandOao.fuCardNum,
      isSpuCard: skuExpandOao.isSpuCard,
    }
    // console.log(`查看`, offerType);

    function getArrayIds(data) {
      if (!data || data.lengt > 0) {
        return []
      }
      let list = []
      data.forEach((element) => {
        element.goodsList.forEach((item) => {
          list.push(item.goods.id)
        })
      })
      return list
    }

    const { msg, data, status } = await broadbandSubmitApi(params)
    return {
      status,
      msg,
    }
  },

  initState({ commit }) {
    commit(`INIT_STATE`)
  },
  isPageInit({ commit }) {
    commit('SET_PAGEINIT')
  },
  setPageCache({ commit }, obj) {
    commit('SET_PAGECACHE', obj)
  },
  setCellPhoneOperator({ commit }, data) {
    commit('SET_CELLPHONEOPERATOR', data)
  },
  setCachedViews({ commit }, data) {
    console.log(`时刻出发`, data)
    commit('SET_CACHEDVIEWS', data)
  },
  setBusinessType({ commit }, type) {
    commit('SET_BUSINESSTYPE', type)
  },
  setUniqueID({ commit }, id) {
    commit('SET_UNIQUEID', id)
  },
  setPayPrice({ commit }, num) {
    commit('SET_PAYPRICE', num)
  },
  setDeliveryMethod({ commit }, data) {
    commit('SET_DELIVERYMETHOD', data)
  },

  setSpecsId({ commit }, id) {
    commit('SET_SPECSID', id)
  },

  setSpecsText({ commit }, text) {
    commit('SET_SPECSTEXT', text)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
